/* LBP — comportements communs : rails, méga-menu, tiroir mobile, recherche, diaporama, tri de collection */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const desktop = window.matchMedia('(min-width: 1041px)');

  /* ── rails : flèches, glisser à la souris ── */
  function initRail(section) {
    const rail = section.querySelector('[data-lbp-rail]');
    if (!rail) return;
    const prev = section.querySelector('[data-lbp-prev]');
    const next = section.querySelector('[data-lbp-next]');
    const box = prev && prev.closest('.lbp-arrows');
    const step = (dir) => {
      const card = rail.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 20;
      rail.scrollBy({ left: dir * (card.offsetWidth + gap) * 2, behavior: reduce ? 'auto' : 'smooth' });
    };
    const arrows = () => {
      if (!prev || !next) return;
      const max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
      if (box) box.toggleAttribute('data-idle', max <= 2);
    };
    if (prev) prev.addEventListener('click', () => step(-1));
    if (next) next.addEventListener('click', () => step(1));

    let drag = null;
    let dragged = false;
    rail.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, left: rail.scrollLeft };
      dragged = false;
    });
    window.addEventListener('pointermove', (e) => {
      if (!drag) return;
      const dx = e.clientX - drag.x;
      if (!dragged && Math.abs(dx) > 6) {
        dragged = true;
        rail.classList.add('is-drag');
      }
      if (dragged) rail.scrollLeft = drag.left - dx;
    });
    window.addEventListener('pointerup', () => {
      if (!drag) return;
      drag = null;
      if (!dragged) return;
      const left = rail.scrollLeft;
      rail.classList.remove('is-drag');
      rail.scrollLeft = left;
    });
    rail.addEventListener('click', (e) => {
      if (dragged) {
        e.preventDefault();
        e.stopPropagation();
        dragged = false;
      }
    }, true);
    rail.addEventListener('dragstart', (e) => e.preventDefault());
    rail.addEventListener('scroll', arrows, { passive: true });
    window.addEventListener('resize', arrows);
    arrows();
  }

  /* ── méga-menu ── */
  function initHeader(hdr) {
    const items = [...hdr.querySelectorAll('[data-lbp-mega]')];
    let openItem = null;
    let closeTimer = null;
    let openTimer = null;
    const setOpen = (item, open) => {
      const panel = item.querySelector('.lbp-panel');
      const link = item.querySelector(':scope > a');
      item.classList.toggle('is-open', open);
      if (panel) panel.hidden = !open;
      if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    const closeAll = () => {
      items.forEach((i) => setOpen(i, false));
      openItem = null;
    };
    const open = (item) => {
      if (openItem === item) return;
      closeAll();
      setOpen(item, true);
      openItem = item;
    };
    items.forEach((item) => {
      const link = item.querySelector(':scope > a');
      item.addEventListener('mouseenter', () => {
        if (!desktop.matches) return;
        clearTimeout(closeTimer);
        openTimer = setTimeout(() => open(item), openItem ? 0 : 110);
      });
      item.addEventListener('mouseleave', () => {
        clearTimeout(openTimer);
        closeTimer = setTimeout(closeAll, 180);
      });
      item.addEventListener('focusin', () => desktop.matches && open(item));
      item.addEventListener('focusout', (e) => {
        if (!item.contains(e.relatedTarget)) setOpen(item, false);
      });
      if (link) {
        link.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            open(item);
            const first = item.querySelector('.lbp-panel a');
            if (first) first.focus();
          }
        });
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || !openItem) return;
      const link = openItem.querySelector(':scope > a');
      closeAll();
      if (link) link.focus();
    });
    document.addEventListener('click', (e) => {
      if (!openItem || openItem.contains(e.target)) return;
      closeAll();
    });
    desktop.addEventListener('change', closeAll);

    /* tiroir mobile */
    const drawer = document.querySelector('[data-lbp-drawer]');
    hdr.querySelectorAll('[data-lbp-drawer-open]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!drawer) return;
        drawer.showModal();
        btn.setAttribute('aria-expanded', 'true');
      });
    });
    if (drawer) {
      drawer.querySelectorAll('[data-lbp-drawer-close]').forEach((b) => b.addEventListener('click', () => drawer.close()));
      drawer.addEventListener('click', (e) => {
        const r = drawer.getBoundingClientRect();
        const inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
        if (!inside) drawer.close();
      });
      drawer.addEventListener('close', () => {
        hdr.querySelectorAll('[data-lbp-drawer-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      });
      drawer.querySelectorAll('summary').forEach((sum) => {
        sum.addEventListener('click', (e) => {
          const a = e.target.closest('a');
          if (!a) return;
          e.preventDefault();
          window.location.assign(a.href);
        });
      });
    }

    /* recherche : fenêtre du thème, sinon page de recherche */
    hdr.querySelectorAll('[data-lbp-search]').forEach((a) => {
      a.addEventListener('click', (e) => {
        const modal = document.getElementById('SearchModal');
        if (!modal || typeof modal.show !== 'function') return;
        e.preventDefault();
        if (drawer && drawer.open) drawer.close();
        modal.show(a);
        const input = modal.querySelector('input[type="search"]');
        if (input) setTimeout(() => input.focus(), 60);
      });
    });
  }

  /* ── diaporama d'accueil ── */
  function initHero(hero) {
    const slides = [...hero.querySelectorAll('[data-lbp-slide]')];
    const dots = [...hero.querySelectorAll('[data-lbp-dot]')];
    if (slides.length < 2) return;
    const delay = (parseInt(hero.dataset.delay, 10) || 6500);
    let cur = 0;
    let timer = null;
    const go = (i) => {
      cur = (i + slides.length) % slides.length;
      slides.forEach((s, k) => {
        const on = k === cur;
        s.classList.toggle('is-on', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.inert = !on;
      });
      dots.forEach((d, k) => d.setAttribute('aria-current', k === cur ? 'true' : 'false'));
    };
    const stop = () => { if (timer) clearInterval(timer); timer = null; };
    const play = () => {
      if (reduce || hero.dataset.autoplay === 'false') return;
      stop();
      timer = setInterval(() => go(cur + 1), delay);
    };
    const nextBtn = hero.querySelector('[data-lbp-hnext]');
    const prevBtn = hero.querySelector('[data-lbp-hprev]');
    if (nextBtn) nextBtn.addEventListener('click', () => { go(cur + 1); play(); });
    if (prevBtn) prevBtn.addEventListener('click', () => { go(cur - 1); play(); });
    dots.forEach((d) => d.addEventListener('click', () => { go(+d.dataset.lbpDot); play(); }));
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', play);
    hero.addEventListener('focusin', stop);

    let x0 = null;
    hero.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 45) { go(cur + (dx < 0 ? 1 : -1)); play(); }
    }, { passive: true });

    go(0);
    play();
  }

  /* ── collection : la page suivante s'ajoute sous les produits, sans remonter en haut ── */
  function initCollPager(root) {
    const grid = root.querySelector('[data-lbp-grid]');
    const pager = root.querySelector('[data-lbp-pager]');
    if (!grid || !pager) return;

    const showProducts = (el) => {
      const bar = root.querySelector('.lbp-fbar');
      const offset = (bar ? bar.offsetHeight : 80) + 12;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    };

    const pageOf = (url) => Number(new URL(url, location.href).searchParams.get('page') || '1');
    if (pageOf(location.href) > 1) showProducts(grid);

    pager.addEventListener('click', async (e) => {
      const a = e.target.closest('a');
      if (!a || !pager.contains(a)) return;
      e.preventDefault();
      if (grid.dataset.loading === '1') return;
      grid.dataset.loading = '1';
      grid.classList.add('is-loading');
      try {
        const res = await fetch(a.href, { headers: { Accept: 'text/html' } });
        if (!res.ok) throw new Error('pager');
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const nextGrid = doc.querySelector('[data-lbp-grid]');
        const nextPager = doc.querySelector('[data-lbp-pager]');
        if (!nextGrid) throw new Error('pager');
        const here = pageOf(location.href);
        const dest = pageOf(a.href);
        const incoming = [...nextGrid.children];
        const first = incoming[0];
        if (dest === here + 1) grid.append(...incoming);
        else grid.replaceChildren(...incoming);
        if (nextPager) pager.innerHTML = nextPager.innerHTML;
        history.pushState({}, '', a.href);
        if (first) showProducts(dest === here + 1 ? first : grid);
        grid.querySelectorAll('[data-lbp-card]').forEach((el) => once(el, initCard));
      } catch (err) {
        location.href = a.href;
      } finally {
        grid.dataset.loading = '0';
        grid.classList.remove('is-loading');
      }
    });

    window.addEventListener('popstate', () => {
      if (root.isConnected) location.reload();
    });
  }

  /* ── carte : survol, balayage des photos, pastille de couleur ── */
  function initCard(card) {
    const ph = card.querySelector('.lbp-ph');
    const imgs = ph ? [...ph.querySelectorAll('img')] : [];
    if (!ph || !imgs.length) return;
    const links = [...card.querySelectorAll('a.lbp-card__go')];
    const priceEl = card.querySelector('[data-lbp-price]');
    let color = (imgs.find((img) => img.classList.contains('is-on')) || imgs[0]).dataset.c;

    const clearMotion = () => {
      imgs.forEach((img) => {
        img.style.transform = '';
        img.style.transition = '';
        img.style.opacity = '';
      });
    };

    const paint = (c) => {
      color = c;
      const set = imgs.filter((img) => img.dataset.c === c);
      const use = set.length ? set : imgs;
      clearMotion();
      imgs.forEach((img) => img.classList.remove('is-on', 'is-next'));
      use[0].classList.add('is-on');
      if (use[1]) use[1].classList.add('is-next');
    };

    const step = (dir) => {
      const set = imgs.filter((img) => img.dataset.c === color);
      const use = set.length ? set : imgs;
      if (use.length < 2) return;
      const i = Math.max(0, use.findIndex((img) => img.classList.contains('is-on')));
      const n = (i + dir + use.length) % use.length;
      use.forEach((img) => img.classList.remove('is-on', 'is-next'));
      use[n].classList.add('is-on');
      use[(n + 1) % use.length].classList.add('is-next');
    };

    card.querySelectorAll('[data-lbp-sw]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        paint(btn.dataset.lbpSw);
        if (btn.dataset.href) links.forEach((a) => { a.href = btn.dataset.href; });
        if (btn.dataset.price && priceEl) priceEl.textContent = btn.dataset.price;
        card.querySelectorAll('[data-lbp-sw]').forEach((b) => {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
      });
    });

    const rail = card.closest('.lbp-rail');
    const activeSet = () => {
      const set = imgs.filter((img) => img.dataset.c === color);
      return set.length ? set : imgs;
    };
    const ease = reduce ? 'none' : 'transform .38s cubic-bezier(.22,0,.2,1)';
    let drag = null;

    const follow = (dx) => {
      const use = activeSet();
      if (use.length < 2) return;
      const w = ph.clientWidth;
      const i = Math.max(0, use.findIndex((img) => img.classList.contains('is-on')));
      const cur = use[i];
      const incoming = use[(i + (dx < 0 ? 1 : -1) + use.length) % use.length];
      imgs.forEach((img) => {
        img.style.transition = 'none';
        if (img !== cur && img !== incoming) img.style.opacity = '0';
      });
      cur.style.opacity = '1';
      cur.style.transform = 'translate3d(' + dx + 'px,0,0)';
      incoming.style.opacity = '1';
      incoming.style.transform = 'translate3d(' + (dx + (dx < 0 ? w : -w)) + 'px,0,0)';
      drag.cur = cur;
      drag.incoming = incoming;
    };

    const release = (commit) => {
      if (!drag || !drag.cur) return;
      const w = ph.clientWidth;
      const dx = drag.dx;
      const go = commit && Math.abs(dx) > Math.max(36, w * 0.18);
      drag.cur.style.transition = ease;
      if (drag.incoming) drag.incoming.style.transition = ease;
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        if (go) step(dx < 0 ? 1 : -1);
        clearMotion();
      };
      if (reduce || !drag.incoming) {
        finish();
        return;
      }
      if (go) {
        const sign = dx < 0 ? -1 : 1;
        drag.cur.style.transform = 'translate3d(' + (sign * w) + 'px,0,0)';
        drag.incoming.style.transform = 'translate3d(0,0,0)';
      } else {
        drag.cur.style.transform = 'translate3d(0,0,0)';
        drag.incoming.style.transform = 'translate3d(' + (dx < 0 ? w : -w) + 'px,0,0)';
      }
      drag.incoming.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 420);
    };

    const settleRail = (dx) => {
      const left = rail.scrollLeft;
      rail.classList.remove('is-drag');
      const item = rail.firstElementChild;
      if (!item) return;
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      const w = item.offsetWidth + gap;
      if (!w) return;
      const threshold = Math.max(36, ph.clientWidth * 0.18);
      const bias = Math.abs(dx) > threshold ? (dx < 0 ? 1 : -1) * w * 0.35 : 0;
      const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const target = Math.min(max, Math.max(0, Math.round((left + bias) / w) * w));
      rail.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
    };

    ph.addEventListener('touchstart', (e) => {
      const t = e.touches[0];
      const box = ph.getBoundingClientRect();
      const rel = (t.clientX - box.left) / box.width;
      drag = {
        x: t.clientX,
        y: t.clientY,
        dx: 0,
        prev: 0,
        axis: null,
        edge: !!(rail && (rel < 0.1 || rel > 0.9)),
        cur: null,
        incoming: null,
      };
    }, { passive: true });
    ph.addEventListener('touchmove', (e) => {
      if (!drag) return;
      const dx = e.touches[0].clientX - drag.x;
      const dy = e.touches[0].clientY - drag.y;
      if (!drag.axis && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) drag.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (drag.axis !== 'x') return;
      e.preventDefault();
      drag.dx = dx;
      if (drag.edge) {
        rail.classList.add('is-drag');
        rail.scrollLeft -= dx - drag.prev;
        drag.prev = dx;
        return;
      }
      follow(dx);
    }, { passive: false });
    const end = (e) => {
      if (!drag) return;
      const moved = drag.axis === 'x' && Math.abs(drag.dx) > 8;
      if (drag.edge) settleRail(drag.dx);
      else release(moved);
      drag = null;
      if (!moved) return;
      ph.dataset.swipe = '1';
      if (e && e.cancelable) e.preventDefault();
    };
    ph.addEventListener('touchend', end);
    ph.addEventListener('touchcancel', () => {
      if (!drag) return;
      if (drag.edge && rail) settleRail(0);
      else release(false);
      drag = null;
    });
    ph.addEventListener('click', (e) => {
      if (ph.dataset.swipe !== '1') return;
      e.preventDefault();
      ph.dataset.swipe = '0';
    });
  }

  /* ── menus à la place des listes natives ── */
  function enhancePick(select) {
    if (!select || select.closest('.lbp-pick')) return;
    const field = select.classList.contains('cart__selector-variant');
    const wrap = document.createElement('div');
    wrap.className = 'lbp-pick' + (field ? ' lbp-pick--field' : '');
    select.parentNode.insertBefore(wrap, select);
    wrap.appendChild(select);
    select.classList.add('lbp-pick__native');
    select.tabIndex = -1;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lbp-pick__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    const label = select.id && document.querySelector('label[for="' + select.id + '"]');
    if (label) btn.setAttribute('aria-label', label.textContent.trim());
    const current = document.createElement('span');
    btn.appendChild(current);
    wrap.insertBefore(btn, select);

    const menu = document.createElement('ul');
    menu.className = 'lbp-pick__menu';
    menu.setAttribute('role', 'listbox');
    menu.hidden = true;
    wrap.appendChild(menu);

    const paint = () => {
      const chosen = select.options[select.selectedIndex];
      current.textContent = chosen ? chosen.textContent.trim() : '';
      menu.replaceChildren();
      [...select.options].forEach((opt, i) => {
        if (opt.disabled && !opt.value) return;
        const li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.dataset.index = String(i);
        li.textContent = opt.textContent.trim();
        if (opt.disabled) li.setAttribute('aria-disabled', 'true');
        if (opt.selected) li.setAttribute('aria-selected', 'true');
        menu.appendChild(li);
      });
    };
    const close = () => {
      menu.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    };
    const place = () => {
      const r = btn.getBoundingClientRect();
      menu.style.position = 'fixed';
      menu.style.left = r.left + 'px';
      menu.style.top = r.bottom + 'px';
      menu.style.width = r.width + 'px';
      menu.style.right = 'auto';
    };
    const open = () => {
      document.querySelectorAll('.lbp-pick__menu').forEach((el) => {
        if (el !== menu) el.hidden = true;
      });
      paint();
      place();
      menu.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
    };
    const choose = (index) => {
      const opt = select.options[index];
      if (!opt || opt.disabled) return;
      select.selectedIndex = index;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      paint();
      close();
    };

    btn.addEventListener('click', () => (menu.hidden ? open() : close()));
    menu.addEventListener('click', (e) => {
      const li = e.target.closest('[role="option"]');
      if (!li || li.getAttribute('aria-disabled') === 'true') return;
      choose(Number(li.dataset.index));
    });
    document.addEventListener('click', (e) => {
      if (!wrap.contains(e.target)) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
    document.addEventListener('scroll', (e) => {
      if (menu.hidden || e.target === menu) return;
      close();
    }, true);
    select.addEventListener('change', paint);
    paint();
  }

  /* ── tri de collection : envoi sans bouton ── */
  function initSort(form) {
    const select = form.querySelector('select');
    if (!select) return;
    select.addEventListener('change', () => form.submit());
    const btn = form.querySelector('[data-lbp-sort-submit]');
    if (btn) btn.hidden = true;
  }

  /* Rail mobile commun : 80 % pour la vignette, 10 % de bord pour avancer. */
  function initLcRail(rail) {
    const phone = window.matchMedia('(max-width: 640px)');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const slides = () => [...rail.children];
    const nearest = () => {
      const mark = rail.getBoundingClientRect().left + rail.clientWidth * 0.1;
      let best = 0;
      let bestDist = Infinity;
      slides().forEach((slide, i) => {
        const dist = Math.abs(slide.getBoundingClientRect().left - mark);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    };
    const go = (index) => {
      const list = slides();
      if (!list.length) return;
      const target = (index + list.length) % list.length;
      const delta = list[target].getBoundingClientRect().left - rail.getBoundingClientRect().left - rail.clientWidth * 0.1;
      rail.scrollTo({ left: Math.max(0, rail.scrollLeft + delta), behavior: 'auto' });
    };
    const step = (dir) => go(nearest() + dir);

    let startX = 0;
    let dragged = false;
    rail.addEventListener('pointerdown', (e) => {
      startX = e.clientX;
      dragged = false;
    });
    rail.addEventListener('pointermove', (e) => {
      if (Math.abs(e.clientX - startX) > 8) dragged = true;
    });
    rail.addEventListener('click', (e) => {
      if (!phone.matches || dragged) {
        dragged = false;
        return;
      }
      const rect = rail.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const edge = rect.width * 0.1;
      if (x >= rect.width - edge) {
        e.preventDefault();
        e.stopPropagation();
        step(1);
      } else if (rail.scrollLeft > 2 && x <= edge) {
        e.preventDefault();
        e.stopPropagation();
        step(-1);
      }
    }, true);

    if (rail.dataset.lcRail !== 'play') return;
    let timer = null;
    let paused = false;
    const stop = () => { clearInterval(timer); timer = null; };
    const play = () => {
      stop();
      if (paused || motion.matches || !phone.matches) return;
      if (document.hidden) return;
      if (rail.scrollWidth <= rail.clientWidth + 2) return;
      timer = setInterval(() => {
        if (!phone.matches || paused || document.hidden) return;
        step(1);
      }, 3200);
    };
    const pause = () => { paused = true; stop(); };
    const resume = () => { paused = false; play(); };
    rail.addEventListener('pointerdown', pause);
    rail.addEventListener('pointerup', resume);
    rail.addEventListener('pointercancel', resume);
    rail.addEventListener('mouseenter', pause);
    rail.addEventListener('mouseleave', resume);
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : play()));
    phone.addEventListener('change', play);
    play();
    const seen = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) play();
      else stop();
    }, { threshold: 0.15 });
    seen.observe(rail);
  }

  function initCollectionFilters(form) {
    const phone = window.matchMedia('(max-width: 640px)');
    const menus = () => [...form.querySelectorAll('details')];
    const place = (details) => {
      const menu = details.querySelector('.menu');
      if (!menu) return;
      if (!details.open || !phone.matches) {
        menu.style.position = '';
        menu.style.top = '';
        menu.style.left = '';
        menu.style.width = '';
        menu.style.maxHeight = '';
        menu.style.overflowY = '';
        return;
      }
      const summary = details.querySelector('summary');
      if (!summary) return;
      const box = summary.getBoundingClientRect();
      const width = Math.min(280, window.innerWidth - 32);
      let left = box.left;
      if (left + width > window.innerWidth - 16) left = window.innerWidth - 16 - width;
      if (left < 16) left = 16;
      menu.style.position = 'fixed';
      menu.style.top = Math.round(box.bottom + 8) + 'px';
      menu.style.left = Math.round(left) + 'px';
      menu.style.width = Math.round(width) + 'px';
      menu.style.maxHeight = '50vh';
      menu.style.overflowY = 'auto';
    };
    menus().forEach((details) => {
      details.addEventListener('toggle', () => {
        if (details.open) {
          menus().forEach((other) => {
            if (other !== details) other.open = false;
          });
        }
        place(details);
      });
    });
    const reposition = () => menus().forEach(place);
    form.addEventListener('scroll', reposition, { passive: true });
    window.addEventListener('scroll', reposition, { passive: true });
    window.addEventListener('resize', reposition);
    phone.addEventListener('change', reposition);
  }

  const once = (el, fn) => {
    if (el.dataset.lbpSite) return;
    el.dataset.lbpSite = '1';
    fn(el);
  };
  const boot = () => {
    document.querySelectorAll('.lc .toolbar').forEach((el) => once(el, initCollectionFilters));
    document.querySelectorAll('[data-lc-rail], .lbp-rail').forEach((el) => once(el, initLcRail));
    document.querySelectorAll('[data-lbp-carrousel]').forEach((el) => once(el, initRail));
    document.querySelectorAll('[data-lbp-header]').forEach((el) => once(el, initHeader));
    document.querySelectorAll('[data-lbp-hero]').forEach((el) => once(el, initHero));
    document.querySelectorAll('[data-lbp-sort]').forEach((el) => once(el, initSort));
    document.querySelectorAll('[data-lbp-coll]').forEach((el) => once(el, initCollPager));
    document.querySelectorAll('[data-lbp-card]').forEach((el) => once(el, initCard));
    document.querySelectorAll('.lbp-fsort select, select.cart__selector-variant').forEach(enhancePick);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('updateCart', () => setTimeout(boot, 40));
  let pickFrame = 0;
  new MutationObserver(() => {
    if (pickFrame) return;
    pickFrame = requestAnimationFrame(() => {
      pickFrame = 0;
      document.querySelectorAll('.lbp-fsort select, select.cart__selector-variant').forEach(enhancePick);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
